module.exports = __webpack_public_path__ + "img/Leumi45.5583b9eb.png";